import { render } from "./ImportIndex.vue?vue&type=template&id=5309bb98"
import script from "./ImportIndex.vue?vue&type=script&lang=js"
export * from "./ImportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__